import { EVENT_TYPE, card } from "../components/ui.js";
import { B } from "../domain/context.js";
import { esc } from "../lib/fmt.js";

// ---------- ETKİNLİKLER ----------
export function viewEtkinlikler() {
  const t = B();
  const today = new Date().toISOString().slice(0, 10);
  return `<div class="space-y-3">
    ${t.events.map(e => {
      const et = EVENT_TYPE[e.type];
      const past = e.date < today;
      const d = new Date(e.date + "T00:00:00");
      return card(`
        <div class="p-4 flex items-center gap-4 ${past ? "opacity-50" : ""}">
          <div class="w-14 shrink-0 text-center rounded-xl py-2" style="background:${et.color}1A">
            <div class="font-display font-extrabold text-xl leading-none" style="color:${et.color}">${d.getDate()}</div>
            <div class="text-[10px] font-bold uppercase" style="color:${et.color}">${d.toLocaleDateString("tr-TR", { month: "short" })}</div>
          </div>
          <div class="min-w-0 flex-1">
            <div class="flex items-center gap-2 flex-wrap">
              <span class="font-semibold">${esc(e.title)}</span>
              <span class="text-[10px] font-bold rounded-full px-2 py-0.5" style="background:${et.color}1A;color:${et.color}">${et.label}</span>
            </div>
            <div class="text-xs text-inksoft mt-0.5">${esc(e.desc)}</div>
          </div>
          <span class="hidden sm:block text-xs text-inksoft shrink-0">${esc(e.scope)}</span>
        </div>`);
    }).join("")}
  </div>`;
}

